// extracted by mini-css-extract-plugin
module.exports = {"comingSoonContainer":"coming-soon-module--coming-soon-container--15mvb"};